<template>
  <v-dialog width="480" v-model="active" persistent>
    <v-card color="primary" class="ui-module-card rounded-sm" v-if="item">
      <v-card-title class="ui-module-titlebar">
        <div class="text-h6">Editar accesorio</div>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="closeDialog()" icon><v-icon>mdi-window-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-form v-model="itemForm" ref="form">
          <v-select
            class="ui-form-field"
            label="Tipo de accesorio"
            v-model="item.fk_idCatTipoItem"
            :items="tipoItem"
            item-color="secondary"
            item-value="id"
            item-text="title"
            rounded
            filled
            dense
            color="secondary"
            background-color="transparent"
            :rules="required"
          >
            <template v-slot:label>Tipo de accesorio <span class="red--text">*</span> </template>
          </v-select>
          <v-text-field
            class="ui-form-field"
            label="Nombre del accesorio"
            v-model="item.item"
            rounded
            filled
            dense
            color="secondary"
            background-color="transparent"
            :rules="required"
          >
            <template v-slot:label>Nombre del accesorio <span class="red--text">*</span> </template>
          </v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center ui-module-actions">
        <v-btn @click="triggerSaveItem()" color="secondary" class="ui-module-btn-solid" :loading="loading" :disabled="loading || !itemForm"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    active: {
      type: Boolean,
    },

    item: {
      type: Object,
    },
  },

  data() {
    return {
      loading: false,
      itemForm: false,

      required: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  computed: {
    ...mapGetters('tipoItemArmeria', {
      tipoItem: 'getTipoItem',
    }),
  },

  methods: {
    ...mapActions('itemArmeria', ['updateItem', 'fetchItems']),

    closeDialog() {
      this.$refs.form.resetValidation()
      this.loading = false
      this.$emit('close')
    },

    async triggerSaveItem() {
      this.loading = true
      await this.updateItem(this.item)
      await this.fetchItems(this.item.fk_idCatTipoItem)

      this.closeDialog()
    },
  },
}
</script>

<style scoped>
.ui-module-card {
  background: rgba(30, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 92, 231, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

::v-deep .ui-module-titlebar {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
}

::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .mdi-menu-down {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label {
  color: #a29bfe !important;
}

::v-deep .ui-module-actions .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
}
</style>
